import React, { useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

const DEFAULT_POPOVER_WIDTH = 280;
const VIEWPORT_PADDING = 8;
const GAP = 4;

const BoardDropdownPortal = ({
  open,
  anchorRef,
  menuRef,
  className = "",
  placement = "bottom-start",
  zIndex = "var(--pb-z-dropdown, 1100)",
  popoverWidth,
  children,
}) => {
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  useLayoutEffect(() => {
    if (!open || !anchorRef?.current) return;

    const updatePosition = () => {
      const anchorRect = anchorRef.current.getBoundingClientRect();
      const menuEl = menuRef?.current;
      const menuWidth = menuEl?.offsetWidth || popoverWidth || DEFAULT_POPOVER_WIDTH;
      const menuHeight = menuEl?.offsetHeight || 0;
      const maxLeft = window.innerWidth - menuWidth - VIEWPORT_PADDING;
      const maxTop = window.innerHeight - menuHeight - VIEWPORT_PADDING;

      let left;
      let top;

      if (placement === "left-start") {
        left = anchorRect.left - menuWidth - GAP;
        top = anchorRect.top;
      } else if (placement === "bottom-end") {
        left = anchorRect.right - menuWidth;
        top = anchorRect.bottom + GAP;
      } else {
        left = anchorRect.left;
        top = anchorRect.bottom + GAP;
      }

      left = Math.max(VIEWPORT_PADDING, Math.min(left, maxLeft));
      top = Math.max(VIEWPORT_PADDING, Math.min(top, maxTop));

      if (menuHeight && top + menuHeight > window.innerHeight - VIEWPORT_PADDING) {
        const aboveTop = anchorRect.top - menuHeight - GAP;
        if (aboveTop >= VIEWPORT_PADDING) {
          top = aboveTop;
        }
      }

      setCoords({ top, left });
    };

    updatePosition();
    const raf = requestAnimationFrame(updatePosition);

    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [open, anchorRef, menuRef, placement, popoverWidth, children]);

  if (!open) return null;

  return createPortal(
    <div
      ref={menuRef}
      className={className}
      style={{
        position: "fixed",
        top: coords.top,
        left: coords.left,
        zIndex,
      }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {children}
    </div>,
    document.body
  );
};

export default BoardDropdownPortal;
